// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const raikou: PokeData = {
  "id": 243,
  "name": "raikou",
  "height": 19,
  "weight": 1780,
  "base_experience": 261,
  "types": [
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "leer",
    "bite",
    "roar",
    "thunder-shock",
    "thunder",
    "quick-attack",
    "reflect",
    "zap-cannon",
    "spark",
    "rain-dance",
    "crunch",
    "extreme-speed",
    "charge",
    "extrasensory",
    "howl",
    "calm-mind",
    "thunder-fang",
    "discharge"
  ],
  "moves": [
    "leer",
    "bite",
    "thunder-shock",
    "thunder",
    "quick-attack",
    "reflect",
    "zap-cannon",
    "rain-dance",
    "crunch",
    "calm-mind",
    "thunder-fang",
    "thunder-punch",
    "volt-switch"
  ],
  "evolution_chain": {
    "id": 123,
    "item": null,
    "species": [
      {
        "name": "raikou",
        "order": 268,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 111,
    "speed": 144,
    "ability_power": 144
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
